import Quack from "./quack";

declare global {
  interface Window {
    Quack: Quack;
  }
}

if (typeof window !== "undefined") {
  const quackInstance = new Quack();
  window.Quack = quackInstance;

  // @ts-ignore - support old implementation
  window["quack"] = quackInstance;
}
